import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import instantChatIcon1 from "../../images/v4/linkGeneration/icons/instantChatIcon1.svg";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import darkGreenCheck from "../../images/v4/industry/education/icons/darkGreenCheck.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import transformBackgroundImage from "../../images/v4/linkGeneration/images/transformBackgroundImage.png";

import partnerSectionBackground from "../../images/v4/linkGeneration/images/partnerSectionBackground.png";

import bestPracticeIcon1 from "../../images/v4/industry/travel/icons/bestPracticeIcon1.svg";
import bestPracticeIcon2 from "../../images/v4/industry/travel/icons/bestPracticeIcon2.svg";
import bestPracticeIcon3 from "../../images/v4/industry/travel/icons/bestPracticeIcon3.svg";
import bestPracticeIcon4 from "../../images/v4/industry/travel/icons/bestPracticeIcon4.svg";
import bestPracticeIcon5 from "../../images/v4/industry/travel/icons/bestPracticeIcon5.svg";
import bestPracticeIcon6 from "../../images/v4/industry/travel/icons/bestPracticeIcon6.svg";

import gridIcon1 from "../../images/v4/industry/travel/icons/gridIcon1.svg";
import gridIcon2 from "../../images/v4/industry/travel/icons/gridIcon2.svg";
import gridIcon3 from "../../images/v4/industry/travel/icons/gridIcon3.svg";
import gridIcon4 from "../../images/v4/industry/travel/icons/gridIcon4.svg";
import gridIcon5 from "../../images/v4/industry/travel/icons/gridIcon5.svg";
import gridIcon6 from "../../images/v4/industry/travel/icons/gridIcon6.svg";
import gridIcon7 from "../../images/v4/industry/travel/icons/gridIcon7.svg";

import bestPracticeBg from "../../images/v4/industry/education/images/bestPracticeBg.png";
import industryHeroSectionBg from "../../images/v4/industry/education/images/industryHeroSectionBg.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/travel/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/industry/travel/compareItemImg5.png";

import featureSectionImg from "../../images/v4/industry/travel/images/featureSectionImg.png";
import meaningImg from "../../images/v4/industry/travel/benefitImg.png";
import benifitImg from "../../images/v4/industry/travel/support.png";
import bodySectionBg from "../../images/v4/industry/travel/images/bodySectionBg.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${industryHeroSectionBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "90px 0 220px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0",
      paddingBottom: "300px",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(0deg, #9227E9 0%, #F77F4C 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  pills: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    // marginTop: "25px",
  },
  pill: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "10px 16px",
    borderRadius: "30px",
    border: "1px solid #CEE9FF",
    gap: "10px",
    "@media only screen and (max-width: 600px)": {
      padding: "10px 15px",
      "& img": {
        width: "20px",
      },
    },
  },
  experienceContainerHeader: {
    display: "flex",
    gap: "20px",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "& h2": {
      width: "55%",
    },
    "& p": {
      width: "45%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      "& h2": {
        width: "100%",
      },
      "& p": {
        width: "100%",
      },
    },
  },
  bodySection: {
    backgroundImage: `url(${bodySectionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "top",
    paddingBottom: "300px",
    paddingTop: "260px",
    "& .container:first-child": {
      padding: "30px 0",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-460px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "500px",
      paddingBottom: "240px",
      "& .container:first-child": {
        padding: "30px 15px",
      },
    },
  },
  gridSection: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    rowGap: "24px",
    marginTop: "60px",
    "@media only screen and (max-width: 600px)": {
      marginTop: "40px",
    },
  },
  gridRow: {
    width: "100%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "24px",
    "&.row1": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "&.row2": {
      "& $gridCard": {
        width: "32%",
      },
    },
    "&.row3": {
      "& $gridCard": {
        width: "49%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  gridCard: {
    display: "flex",
    flexDirection: "column",
    width: "48%",
    padding: "24px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    background: "#ffffff1a",
    borderRadius: "16px",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    gap: "16px",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100% !important",
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bestPracticeBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      paddingBottom: "170px",
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#fff",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "24px",
    width: "30%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(90deg, #011D32 0%, #00182B 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "75%",
    "@media only screen and (max-width: 600px)": {
      top: "91%",
    },
  },
  stripSection: {
    paddingTop: "280px",
    backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "180px",
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(0deg, #009A99 0%, #005353 100%)",
      flexDirection: "row-reverse",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& $supportBox": {
        top: "-830px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  featureSection: {
    padding: "60px 0",
    background: "#F7F1FB",
  },
  featureSectionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row-reverse",
    gap: "30px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  featureContainerLeft: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  featureContainerRight: {
    width: "50%",
    gap: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "& $cardPointer": {
      alignItems: "flex-start",
      "& img": {
        position: "relative",
        top: "5px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        position: "relative",
        top: "5px",
        width: "20px",
      },
    },
  },
  wpFaq: {
    // padding: "40px 0",
    "& $faqSection": {
      padding: 0,
    },
    background: "#F1FFF9",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  // testimonials: {
  //   paddingBottom: "40px",
  // },
}));

const TravelIndustry = () => {
  const classes = useStyles();
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question: "What is a travel agency CRM used for?",
      answer: (
        <>
          A travel agency CRM helps streamline lead management, automate
          follow-ups, manage client data, coordinate vendors, and boost sales.
        </>
      ),
    },
    {
      question: "Is it mobile-friendly for agents on the move?",
      answer: (
        <>
          Definitely! Our mobile-optimised interface allows agents to access
          bookings, respond to leads, and update itineraries on the go.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud suitable for small/mid-sized travel agencies?",
      answer: (
        <>
          Absolutely. Pepper Cloud is designed to scale with your business,
          offering customisable features that cater to both small and mid-sized
          travel agencies aiming for growth.​
        </>
      ),
    },
    {
      question: "How does a travel CRM assist in lead management?",
      answer: (
        <>
          Travel CRMs streamline lead management by capturing inquiries from
          various channels, automating follow-ups, and tracking the sales
          pipeline, ensuring no opportunity is missed.
        </>
      ),
    },
    {
      question: "How scalable is Pepper Cloud for travel businesses?",
      answer: (
        <>
          Whether you're a solo agent or an expanding agency, Pepper Cloud
          scales with you. It’s one of the few CRM systems for travel agency
          setups that grows without compromising performance.
        </>
      ),
    },
    {
      question: "How is a travel agency CRM different from a regular CRM?",
      answer: (
        <>
          A travel CRM is built for the industry's needs, managing trips,
          clients, docs, and inquiries, unlike generic CRMs focused on sales.
        </>
      ),
    },
    {
      question: "Why is travel CRM important?",
      answer: (
        <>
          A travel CRM streamlines lead management, follow-ups, and booking
          processes. It helps boost efficiency, enhance customer experience, and
          grow repeat business for travel agencies!
        </>
      ),
    },
  ];
  const features1 = [
    {
      icon: gridIcon1,
      alt: "",
      heading: "Unified dashboard",
      desc: "View clients, bookings, itineraries, payments, and chats in one place-no more tool-hopping.",
    },
    {
      icon: gridIcon2,
      alt: "",
      heading: "Automated follow-ups",
      desc: "Send trip updates, payment reminders, and follow-ups via Email, WhatsApp, and SMS- all automated.",
    },
  ];
  const features2 = [
    {
      icon: gridIcon3,
      alt: "",
      heading: "AI-powered insights",
      desc: "Leverage AssistAI for smart suggestions based on client history, preferences, and interactions.",
    },
    {
      icon: gridIcon4,
      alt: "",
      heading: "Mobile-friendly access",
      desc: "Manage your agency anytime, anywhere with our mobile-optimised travel agency CRM.",
    },
    {
      icon: gridIcon5,
      alt: "",
      heading: "End-to-end lead and booking management",
      desc: "Track every client journey from inquiry to confirmation-seamlessly.",
    },
  ];
  const features3 = [
    {
      icon: gridIcon6,
      alt: "",
      heading: "Effortless onboarding",
      desc: " Migrate your data smoothly with zero disruption to your travel workflows.",
    },
    {
      icon: gridIcon7,
      alt: "",
      heading: "Lead capture & tracking",
      desc: "Auto-capture leads from web forms, social media, WhatsApp, and landing pages into your CRM system for travel agencies.",
    },
  ];
  const bestPractice = [
    {
      icon: bestPracticeIcon1,
      alt: "",
      heading: "Segment by preferences",
      desc: "Hone your communication for corporate, leisure, or luxury travellers.",
    },
    {
      icon: bestPracticeIcon2,
      alt: "",
      heading: "Automate check-ins",
      desc: "Schedule reminders before take-off, during the trip, and post-return.",
    },
    {
      icon: bestPracticeIcon3,
      alt: "",
      heading: "Custom proposal templates",
      desc: "Build visually engaging, ready-to-send itineraries in minutes.",
    },
    {
      icon: bestPracticeIcon4,
      alt: "",
      heading: "Priorities lead scoring",
      desc: "Focus your energy where it matters most.",
    },
    {
      icon: bestPracticeIcon5,
      alt: "",
      heading: "Study trends",
      desc: "Use CRM analytics to see what’s hot and where interest is growing.",
    },
    {
      icon: bestPracticeIcon6,
      alt: "",
      heading: "Centralised communication",
      desc: "Store every interaction so nothing gets missed.",
    },
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Pipedrive CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "As the best CRM software for travel agencies, Pepper Cloud is powerful yet simple, covering everything from automation to mobility and omnichannel communication, making it ideal for today’s fast-paced travel landscape.​",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "Broadcast promotions",
          desc: "Schedule and send destination deals and seasonal offers via WhatsApp and Email.",
        },
        {
          title: "WhatsApp group",
          desc: "Handle group chats, bookings, and customer care directly from your CRM.",
        },
        {
          title: "Knowledge Link",
          desc: "Equip your team and chatbot with instant access to pre-approved responses.",
        },
        {
          title: "WhatsApp flows & automation",
          desc: "Capture leads, manage bookings, and collect feedback directly via WhatsApp.",
        },
        {
          title: "AI sales automation",
          desc: "Auto-assign leads, summarise conversations, and send instant replies using AssistAI.",
        },
        {
          title: "Media templates",
          desc: "Respond instantly with personalised offers, photos, and videos.",
        },
        {
          title: "Real-time order updates",
          desc: "Keep clients informed with automatic booking and delivery notifications.",
        },
        {
          title: "Smart Lead Flow",
          desc: "Convert leads with personalised messages and timely follow-ups.",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM excels in marketing and lead nurturing. If your agency relies on inbound campaigns and email marketing, it could be the perfect fit.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Email campaigns",
          desc: "Share destination guides, deals, and promotions easily.",
        },
        {
          title: "Meeting scheduler",
          desc: "Book discovery calls or trip consultations with ease.",
        },
        {
          title: "Dash Analytics",
          desc: "Stay updated on which campaigns and packages are performing best.",
        },
      ],
    },
    {
      title: "Salesforce CRM",
      desc: "For larger agencies or OTAs handling high volumes and complex processes, Salesforce’s travel solution is a powerhouse.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Custom Journeys",
          desc: "Create detailed, tailored experiences based on client data.​",
        },
        {
          title: "Travel product",
          desc: "Manage bookings, transport, and tours.",
        },
        {
          title: "360° view",
          desc: "Track client interactions pre, during, and post-trip.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "It covers all the essentials without stretching your finances and is super easy to navigate, even if you're new to using CRMs.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Workflow automation",
          desc: "Set up auto-reminders, approvals, and follow-ups so you never miss a beat.",
        },
        {
          title: "Mobile access",
          desc: "Take your bookings, client info, and sales pipeline with you wherever you go.",
        },
        {
          title: "Social Integration",
          desc: "Convert DMs into leads from Facebook & Instagram.",
        },
      ],
    },
    {
      title: "Pipedrive CRM",
      desc: "If you prefer a clean, drag-and-drop interface, this flexible tool fits smoothly into any travel professional’s daily workflow.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "Custom pipelines",
          desc: "Easily drag leads from inquiry to booking at a glance.",
        },
        {
          title: "Auto follow-ups",
          desc: " Never miss a follow-up with a potential traveller.",
        },
        {
          title: "Lead capture forms",
          desc: "Embed on your site to capture leads effortlessly.",
        },
      ],
    },
  ];
  const industryFeature = [
    {
      title: "Look for travel-specific features",
      desc: " CRMs like Pepper Cloud offer itineraries, lead scoring & automation.",
    },
    {
      title: "Look for scalability",
      desc: "Ease of use matters: Your CRM system for a travel agency should feel as smooth as planning your dream vacation.",
    },
    {
      title: "Integration is key",
      desc: "Integrate bookings, payments & emails in one CRM.",
    },
    {
      title: "Automate the routine",
      desc: "Let your CRM handle repetitive tasks so you can focus on the human touch.",
    },
    {
      title: "Stay mobile-ready",
      desc: "Your team should be able to manage leads and bookings even while traveling themselves.",
    },
  ];
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <main>
      <SEO
        description={
          "Streamline bookings, automate follow-ups & boost sales with Pepper Cloud CRM—built for modern travel agents to grow smarter and faster."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is a travel agency CRM used for?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A travel agency CRM helps streamline lead management, automate follow-ups, manage client data, coordinate vendors, and boost sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is it mobile-friendly for agents on the move?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Definitely! Our mobile-optimised interface allows agents to access bookings, respond to leads, and update itineraries on the go.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud suitable for small/mid-sized travel agencies?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. Pepper Cloud is designed to scale with your business, offering customisable features that cater to both small and mid-sized travel agencies aiming for growth.​",
                },
              },
              {
                "@type": "Question",
                name: "How does a travel CRM assist in lead management?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Travel CRMs streamline lead management by capturing inquiries from various channels, automating follow-ups, and tracking the sales pipeline, ensuring no opportunity is missed.",
                },
              },
              {
                "@type": "Question",
                name: "How scalable is Pepper Cloud for travel businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Whether you're a solo agent or an expanding agency, Pepper Cloud scales with you. It’s one of the few CRM systems for travel agency setups that grows without compromising performance.",
                },
              },
              {
                "@type": "Question",
                name: "How is a travel agency CRM different from a regular CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A travel CRM is built for the industry's needs, managing trips, clients, docs, and inquiries, unlike generic CRMs focused on sales.",
                },
              },
              {
                "@type": "Question",
                name: "Why is travel CRM important?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A travel CRM streamlines lead management, follow-ups, and booking processes. It helps boost efficiency, enhance customer experience, and grow repeat business for travel agencies!",
                },
              },
            ],
          },
        ]}
        keywords="crm with whatsapp integration, crm whatsapp integration, whatsapp integration, WhatsApp-enabled CRM"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/whatsapp-crm/"}
        title={"Best CRM software for travel agencies | Pepper Cloud CRM"}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              className="font-wix-semibold font-18"
              initial={{ opacity: 1, y: 20 }}
              style={{ color: "#0291AE" }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Travel agencies
            </motion.h1>
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Best CRM software for travel agencies
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Simplify itinerary management, client communication, and bookings
              with Pepper Cloud—the best CRM software for travel agencies.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  alt={"pointer"}
                  className={classes.pointerImg}
                  source={greenCheckCircle}
                />
                <p className="font-inter-regular font-18">
                  Manage bookings & queries
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  alt={"pointer"}
                  className={classes.pointerImg}
                  source={greenCheckCircle}
                />
                <p className="font-inter-regular font-18">
                  Automate lead follow-ups
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  alt={"pointer"}
                  className={classes.pointerImg}
                  source={greenCheckCircle}
                />
                <p className="font-inter-regular font-18">
                  On-the-go tools for agents
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link className="primaryButton font-20 font-wix-medium font-white">
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.bodySection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What is CRM in the travel industry?
              </p>
              <p
                className="font-18 font-inter-regular"
                style={{ color: "#fff" }}
              >
                A CRM system for travel agencies brings all your leads,
                bookings, and client chats into one simple dashboard. It helps
                you stay on top of follow-ups, vendor coordination, and trip
                planning—without the chaos. Perfect for travel professionals who
                want to work smarter and grow faster.
              </p>
              <div className={classes.pills}>
                <div className={classes.pill}>
                  <LazyImage
                    alt={"pointer"}
                    className={classes.pointerImg}
                    source={whiteCheckCircle}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    AI-powered
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    alt={"pointer"}
                    className={classes.pointerImg}
                    source={whiteCheckCircle}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    WhatsApp capabilities
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    alt={"pointer"}
                    className={classes.pointerImg}
                    source={whiteCheckCircle}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    Easy to use
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    alt={"pointer"}
                    className={classes.pointerImg}
                    source={whiteCheckCircle}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    24/7 Local support
                  </p>
                </div>
                <div className={classes.pill}>
                  <LazyImage
                    alt={"pointer"}
                    className={classes.pointerImg}
                    source={whiteCheckCircle}
                  />
                  <p className="font-inter-regular font-16 font-white">
                    No hidden charges
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                alt={"Benefits of WhatsApp link generator"}
                className={classes.broadcastImg}
                source={meaningImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className={classes.experienceContainerHeader}>
            <motion.h2
              className="font-wix-semibold font-56 font-white"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is the best CRM for travel agencies
            </motion.h2>
            <motion.p
              className="font-inter-regular font-18"
              initial={{ opacity: 1, y: 20 }}
              style={{ color: "#A2BED3" }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Pepper Cloud stands out as a travel agency CRM specifically
              designed to meet the unique needs of travel professionals.
            </motion.p>
          </div>
          <div className={classes.gridSection}>
            <div className={clsx(classes.gridRow, "row1")}>
              {features1.map((feature) => (
                <div className={classes.gridCard}>
                  <img alt={feature.alt} src={feature.icon} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row2")}>
              {features2.map((feature) => (
                <div className={classes.gridCard}>
                  <img alt={feature.alt} src={feature.icon} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <div className={clsx(classes.gridRow, "row3")}>
              {features3.map((feature) => (
                <div className={classes.gridCard}>
                  <img alt={feature.alt} src={feature.icon} />
                  <p className="font-wix-semibold font-24 font-white">
                    {feature.heading}
                  </p>
                  <p
                    className="font-16 font-wix-medium"
                    style={{ color: "#C0CFDD" }}
                  >
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                What are the benefits of using travel CRM software
              </p>
              <div className={classes.pointers}>
                <div className={classes.cardPointer}>
                  <LazyImage
                    alt={"pointer"}
                    className={classes.pointerImg}
                    source={whiteCheckCircle}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Build stronger client relationships with detailed
                    interaction histories and personalised communication.​
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    alt={"pointer"}
                    className={classes.pointerImg}
                    source={whiteCheckCircle}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Streamline bookings and marketing by automating follow-ups,
                    quotes, and itinerary updates.​
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    alt={"pointer"}
                    className={classes.pointerImg}
                    source={whiteCheckCircle}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Save time with smart workflows that reduce manual tasks and
                    boost efficiency.​
                  </p>
                </div>
                <div className={classes.cardPointer}>
                  <LazyImage
                    alt={"pointer"}
                    className={classes.pointerImg}
                    source={whiteCheckCircle}
                  />
                  <p className="font-inter-regular font-18 font-white">
                    Make better decisions with real-time insights into bookings,
                    agent performance, and seasonal trends.​
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                alt={"Benefits of WhatsApp link generator"}
                className={classes.broadcastImg}
                source={benifitImg}
              />
            </div>
          </motion.div>
        </div>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              5 best CRM for travel agencies in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-inter-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.featureSection}>
        <div className="container">
          <div className={classes.featureSectionContainer}>
            <div className={classes.featureContainerLeft}>
              <LazyImage alt={""} source={featureSectionImg} width={"100%"} />
            </div>
            <div className={classes.featureContainerRight}>
              <p className="font-wix-medium font-40 color-black1">
                How to choose the best travel CRM software
              </p>
              <div className={classes.pointers}>
                {industryFeature.map((point) => (
                  <div className={classes.cardPointer}>
                    <LazyImage alt={"pointer"} source={darkGreenCheck} />
                    <p className="font-18 font-inter-regular color-black1">
                      {point.title}: {point.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              CRM for travel industry: Best practices
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img alt={practice.alt} src={practice.icon} />
                <p className="font-wix-semibold font-24 font-black1">
                  {practice.heading}
                </p>
                <p className="font-wix-medium font-16 font-black1">
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              className="font-wix-semibold font-24 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
          className={classes.partnerSlider}
          loop={true}
          modules={[Autoplay]}
          slidesPerView="auto"
          spaceBetween={60}
          speed={3000}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img alt={partner.alt} src={partner.icon} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#F1FFF9"}
          faqs={faqs}
          heading={"FAQs – travel agency CRM Software"}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Power your travel business with the best CRM software for travel
              agencies!
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TravelIndustry;
